/*
 * ENV variables overrides might be passed through "window.env" object
 */

const readVariable = (varName, defaultValue) => {
  if (window.env && window.env[varName]) {
    return window.env[varName];
  }
  if (window.Cypress && window.Cypress.env(varName)) {
    return window.Cypress.env(varName);
  }
  return defaultValue;
};

export function getAppEnv() {
  return readVariable('REACT_APP_ENV', process.env.REACT_APP_ENV);
}

export function getBackendUrl() {
  return (
    readVariable('REACT_APP_BACKEND', process.env.REACT_APP_BACKEND) + '/content_creator_platform'
  );
}

export function getBackendRootUrl() {
  return readVariable('REACT_APP_BACKEND', process.env.REACT_APP_BACKEND);
}

export function getAuthorCompleteExtensionID() {
  return readVariable(
    'REACT_APP_KEYWEE_AUTHOR_COMPLETE_EXTENSION_ID',
    process.env.REACT_APP_KEYWEE_AUTHOR_COMPLETE_EXTENSION_ID
  );
}

export function getFacebookAppID() {
  return readVariable('REACT_APP_FACEBOOK_APP_ID', process.env.REACT_APP_FACEBOOK_APP_ID);
}

export function getSentryDSN() {
  return readVariable('REACT_APP_SENTRY_DSN', process.env.REACT_APP_SENTRY_DSN);
}

export function getUnsplashID() {
  return readVariable('REACT_APP_UNSPLASH_ID', process.env.REACT_APP_UNSPLASH_ID);
}

export function getMixpanelToken() {
  return readVariable('REACT_APP_MIXPANEL_TOKEN', process.env.REACT_APP_MIXPANEL_TOKEN);
}

export function getStripeApiKey() {
  return readVariable('REACT_APP_STRIPE_API_KEY', process.env.REACT_APP_STRIPE_API_KEY);
}

export function getChurnkeyAppId() {
  return readVariable('REACT_APP_CHURNKEY_APP_ID', process.env.REACT_APP_CHURNKEY_APP_ID);
}

export function getChurnkeyMode() {
  return readVariable('REACT_APP_CHURNKEY_MODE', process.env.REACT_APP_CHURNKEY_MODE);
}

export function getGrammarlyClientId() {
  return readVariable('REACT_APP_GRAMMARLY_CLIENT_ID', process.env.REACT_APP_GRAMMARLY_CLIENT_ID);
}

export function getWebsiteOrigin() {
  return readVariable('REACT_APP_WEBSITE_ORIGIN', process.env.REACT_APP_WEBSITE_ORIGIN);
}
